export function getAuthentication(server, site) {
  return server + '/authenticate?site=' + site
}

export function getShipment(user, proposal, shippingId) {
  return user.server + `/${user.token}/proposal/${proposal}/shipping/${shippingId}/get`
}

export function getDewarsAdd(user, proposal, shippingId) {
  return user.server + `/${user.token}/proposal/${proposal}/shipping/${shippingId}/dewars/add`
}

export function getShipmentSaved(user, proposal) {
  return user.server + `/${user.token}/proposal/${proposal}/shipping/save`
}

export function getShipmentList(user, proposal) {
  return user.server + `/${user.token}/proposal/${proposal}/shipping/list`
}

export function getParcelSaved(user, proposal, shippingId) {
  return user.server + `/${user.token}/proposal/${proposal}/shipping/${shippingId}/dewar/save`
}

export function getSessions(user) {
  return user.server + '/:token/session/list'.replace(':token', user.token)
}

export function getSessionsByProposal(user, proposal) {
  return (
    user.server + '/:token/proposal/:proposal/session/list'.replace(':token', user.token).replace(':proposal', proposal)
  )
}

export function getProposals(user) {
  return user.server + '/:token/proposal/list'.replace(':token', user.token)
}

export function getSessionsByDate(user, startDate, endDate) {
  return (
    user.server +
    '/:token/proposal/session/date/:startDate/:endDate/list'
      .replace(':token', user.token)
      .replace(':startDate', startDate)
      .replace(':endDate', endDate)
  )
}

/********************
 * SAXS
 ********************/
export function getProposalInfo(user, proposal) {
  return (
    user.server + '/:token/proposal/:proposal/info/get'.replace(':token', user.token).replace(':proposal', proposal)
  )
}

export function getSaxsExperimentsBySessionId(user, proposal, sessionId) {
  return (
    user.server +
    '/:token/proposal/:proposal/saxs/experiment/session/:sessionId/list'
      .replace(':token', user.token)
      .replace(':proposal', proposal)
      .replace(':sessionId', sessionId)
  )
}

export function getSaxsExperimentByExperimentId(user, proposal, experimentId) {
  return (
    user.server +
    '/:token/proposal/:proposal/saxs/experiment/:experimentId/get'
      .replace(':token', user.token)
      .replace(':proposal', proposal)
      .replace(':experimentId', experimentId)
  )
}

/** Get extended subtractions associated to a given experiment. 'Extended' indicates that subtraction entoty is enriched by associated entities */
export function getSaxsExtendedSubtractionsByExperimentId(user, proposal, experimentId) {
  return (
    user.server +
    '/:token/proposal/:proposal/saxs/datacollection/experiment/:experimentId/list'
      .replace(':token', user.token)
      .replace(':proposal', proposal)
      .replace(':experimentId', experimentId)
  )
}

export function getSaxsScatteringPlot(user, proposal, subtractionId) {
  return (
    user.server +
    '/:token/proposal/:proposal/saxs/subtraction/:subtractionId/image/scattering'
      .replace(':token', user.token)
      .replace(':proposal', proposal)
      .replace(':subtractionId', subtractionId)
  )
}

export function getSaxsKratkyPlot(user, proposal, subtractionId) {
  return (
    user.server +
    '/:token/proposal/:proposal/saxs/subtraction/:subtractionId/image/kratky'
      .replace(':token', user.token)
      .replace(':proposal', proposal)
      .replace(':subtractionId', subtractionId)
  )
}

export function getSaxsDensityPlot(user, proposal, subtractionId) {
  return (
    user.server +
    '/:token/proposal/:proposal/saxs/subtraction/:subtractionId/image/density'
      .replace(':token', user.token)
      .replace(':proposal', proposal)
      .replace(':subtractionId', subtractionId)
  )
}

export function getSaxsGuinierPlot(user, proposal, subtractionId) {
  return (
    user.server +
    '/:token/proposal/:proposal/saxs/subtraction/:subtractionId/image/guinier'
      .replace(':token', user.token)
      .replace(':proposal', proposal)
      .replace(':subtractionId', subtractionId)
  )
}
// get datacollections
export function getSaxsDataCollectionsAsBeanByDataCollectionIds(user, proposal, dataCollectionIds) {
  return (
    user.server +
    '/:token/proposal/:proposal/saxs/datacollection/dataCollectionId/:dataCollectionIds/bean'
      .replace(':token', user.token)
      .replace(':proposal', proposal)
      .replace(':dataCollectionIds', dataCollectionIds)
  )
}

// END get dataCollections

// subtractions related
export function getSubtractionsAsListByDataCollectionIds(user, proposal, dataCollectionIds) {
  return (
    user.server +
    '/:token/proposal/:proposal/saxs/datacollection/:dataCollectionId/list'
      .replace(':token', user.token)
      .replace(':proposal', proposal)
      .replace(':dataCollectionId', dataCollectionIds)
  )
}

export function getSaxsSubtractionAsListBySubtractionId(user, proposal, subtractionId) {
  return (
    user.server +
    '/:token/proposal/:proposal/saxs/subtraction/:subtractionId/list'
      .replace(':token', user.token)
      .replace(':proposal', proposal)
      .replace(':subtractionId', subtractionId)
  )
}

export function getSaxsHPLCFrame(user, proposal, experimentId, frameId) {
  return (
    user.server +
    '/:token/proposal/:proposal/saxs/experiment/:experimentId/hplc/frame/:frameId/get?operation=log'
      .replace(':token', user.token)
      .replace(':proposal', proposal)
      .replace(':experimentId', experimentId)
      .replace(':frameId', frameId)
  )
}

export function downloadFramesByAverageIdList(user, proposal, mergeId) {
  return (
    user.server +
    '/:token/proposal/:proposal/saxs/frame/:mergeId/zip'
      .replace(':token', user.token)
      .replace(':proposal', proposal)
      .replace(':mergeId', mergeId)
  )
}

/**
 * URL to get contiguous frames for an HPLC experiment
 * @param {*} token ispyb token
 * @param {*} proposal proposal name
 * @param {*} experimentId experiment identifier
 * @param {*} startFrameId start frame identifier
 * @param {*} endFrameId end frame identifier
 */
export function getDownloadHDF5FramesURL(user, proposal, experimentId, startFrameId, endFrameId) {
  return (
    user.server +
    '/:token/proposal/:proposal/saxs/experiment/:experimentId/hplc/frame/:startFrameId/:endFrameId/zip'
      .replace(':token', user.token)
      .replace(':proposal', proposal)
      .replace(':experimentId', experimentId)
      .replace(':startFrameId', startFrameId)
      .replace(':endFrameId', endFrameId)
  )
}

/** Get merge entities associated to a given datacollection. 'Extended' indicates that additional properties from associated entities are provided. */
export function getExtendedMergesByMergeIds(user, proposal, mergeIds) {
  return (
    user.server +
    '/:token/proposal/:proposal/saxs/frame/average/:mergeIds/bean'
      .replace(':token', user.token)
      .replace(':proposal', proposal)
      .replace(':mergeIds', mergeIds)
  )
}

// plotting data related
export function getPlottingDataByFrame(
  user,
  frameId,
  averageId,
  subtractedId,
  sampleAverageId,
  bufferAverageId,
  models,
  operation
) {
  return (
    user.server +
    '/:token/proposal/:proposal/saxs/frame/datplot?frame=:frameId&average=:averageId&subtracted=:subtractedId&sampleaverage=:sampleAverageId&bufferaverage=:bufferAverageId&models=:models&operation=:operation'
      .replace(':token', user.token)
      .replace(':proposal', 'undefined')
      .replace(':frameId', frameId || '')
      .replace(':averageId', averageId || '')
      .replace(':subtractedId', subtractedId || '')
      .replace(':sampleAverageId', sampleAverageId || '')
      .replace(':bufferAverageId', bufferAverageId || '')
      .replace(':models', models || '')
      .replace(':operation', operation || '')
      .replace(':proposal', 'undefined')
  )
}

export function getFirContentByModelId(user, proposal, subtractionId, modelId) {
  return (
    user.server +
    '/:token/proposal/:proposal/saxs/subtraction/:subtractionId/model/:modelId/fir/content'
      .replace(':token', user.token)
      .replace(':proposal', proposal)
      .replace(':subtractionId', subtractionId)
      .replace(':modelId', modelId)
  )
}

export function getFitContentByModelId(user, proposal, subtractionId, modelId) {
  return (
    user.server +
    '/:token/proposal/:proposal/saxs/subtraction/:subtractionId/model/:modelId/fit/content'
      .replace(':token', user.token)
      .replace(':proposal', proposal)
      .replace(':subtractionId', subtractionId)
      .replace(':modelId', modelId)
  )
}

// HPLC related calls
export function getHPLCOverviewByExperimentId(user, proposal, experimentId) {
  return (
    user.server +
    '/:token/proposal/:proposal/saxs/experiment/:experimentId/hplc/overview'
      .replace(':token', user.token)
      .replace(':proposal', proposal)
      .replace(':experimentId', experimentId)
  )
}

// Others
export function getNSDURLbyModelListId(user, subtractionId, modelListId) {
  return (
    user.server +
    '/:token/proposal/:proposal/saxs/subtraction/:subtractionId/modellist/:modelListId/nsd'
      .replace(':token', user.token)
      .replace(':proposal', 'undefined')
      .replace(':subtractionId', subtractionId)
      .replace(':modelListId', modelListId)
  )
}

export function getChi2RgURLbyModelListId(user, subtractionId, modelListId) {
  return (
    user.server +
    '/:token/proposal/:proposal/saxs/subtraction/:subtractionId/modellist/:modelListId/chi2rg'
      .replace(':token', user.token)
      .replace(':proposal', 'undefined')
      .replace(':subtractionId', subtractionId)
      .replace(':modelListId', modelListId)
  )
}

export function getPDBByModelId(user, proposal, subtractionId, modelId) {
  return (
    user.server +
    '/:token/proposal/:proposal/saxs/subtraction/:subtractionId/model/:modelId/pdb'
      .replace(':token', user.token)
      .replace(':proposal', proposal)
      .replace(':subtractionId', subtractionId)
      .replace(':modelId', modelId)
  )
}

export function getFirByModelId(user, proposal, subtractionId, modelId) {
  return (
    user.server +
    '/:token/proposal/:proposal/saxs/subtraction/:subtractionId/model/:modelId/fir'
      .replace(':token', user.token)
      .replace(':proposal', proposal)
      .replace(':subtractionId', subtractionId)
      .replace(':modelId', modelId)
  )
}

export function getLogByModelId(user, proposal, subtractionId, modelId) {
  return (
    user.server +
    '/:token/proposal/:proposal/saxs/subtraction/:subtractionId/model/:modelId/log'
      .replace(':token', user.token)
      .replace(':proposal', proposal)
      .replace(':subtractionId', subtractionId)
      .replace(':modelId', modelId)
  )
}

export function getPDB(user, proposal) {
  return (
    user.server +
    '/:token/proposal/:proposal/saxs/modeling/pdb/get'.replace(':token', user.token).replace(':proposal', proposal)
  )
}

export function getZip(user, proposal, subtractionId) {
  return (
    user.server +
    '/:token/proposal/:proposal/saxs/subtraction/:subtractionId/zip'
      .replace(':token', user.token)
      .replace(':proposal', proposal)
      .replace(':subtractionId', subtractionId)
  )
}

export function saveMacromolecule(user, proposal) {
  return (
    user.server +
    '/:token/proposal/:proposal/saxs/macromolecule/save'.replace(':token', user.token).replace(':proposal', proposal)
  )
}

export function saveBuffer(user, proposal) {
  return (
    user.server +
    '/:token/proposal/:proposal/saxs/buffer/save'.replace(':token', user.token).replace(':proposal', proposal)
  )
}

/********************
 * EM
 ********************/

export function getEmDataColletionBySessionId(user, proposal, sessionId) {
  return (
    user.server +
    '/:token/proposal/:proposal/em/datacollection/session/:sessionId/list'
      .replace(':token', user.token)
      .replace(':proposal', proposal)
      .replace(':sessionId', sessionId)
  )
}

export function getEmMoviesByDataCollectionId(user, proposal, dataCollectionId) {
  return (
    user.server +
    '/:token/proposal/:proposal/em/datacollection/:dataCollectionId/movie/all'
      .replace(':token', user.token)
      .replace(':proposal', proposal)
      .replace(':dataCollectionId', dataCollectionId)
  )
}

export function getMovieThumbnail(user, proposal, dataCollectionId, movieId) {
  return (
    user.server +
    '/:token/proposal/:proposal/em/datacollection/:dataCollectionId/movie/:movieId/thumbnail'
      .replace(':token', user.token)
      .replace(':proposal', proposal)
      .replace(':dataCollectionId', dataCollectionId)
      .replace(':movieId', movieId)
  )
}

export function getMotionCorrectionDrift(user, proposal, dataCollectionId, movieId) {
  return (
    user.server +
    '/:token/proposal/:proposal/em/datacollection/:dataCollectionId/movie/:movieId/motioncorrection/drift'
      .replace(':token', user.token)
      .replace(':proposal', proposal)
      .replace(':dataCollectionId', dataCollectionId)
      .replace(':movieId', movieId)
  )
}

export function getMotionCorrectionThumbnail(user, proposal, dataCollectionId, movieId) {
  return (
    user.server +
    '/:token/proposal/:proposal/em/datacollection/:dataCollectionId/movie/:movieId/motioncorrection/thumbnail'
      .replace(':token', user.token)
      .replace(':proposal', proposal)
      .replace(':dataCollectionId', dataCollectionId)
      .replace(':movieId', movieId)
  )
}

export function getCTFThumbnail(user, proposal, dataCollectionId, movieId) {
  return (
    user.server +
    '/:token/proposal/:proposal/em/datacollection/:dataCollectionId/movie/:movieId/ctf/thumbnail'
      .replace(':token', user.token)
      .replace(':proposal', proposal)
      .replace(':dataCollectionId', dataCollectionId)
      .replace(':movieId', movieId)
  )
}

export function getEmStats(user, proposal, sessionId) {
  return (
    user.server +
    '/:token/proposal/:proposal/em/session/:sessionId/stats'
      .replace(':token', user.token)
      .replace(':proposal', proposal)
      .replace(':sessionId', sessionId)
  )
}

/********************
 * MX
 ********************/

export function updateShippingStatus(user, proposal, shippingId, status) {
  return (
    user.server +
    '/:token/proposal/:proposal/shipping/:shippingId/status/:status/update'
      .replace(':token', user.token)
      .replace(':proposal', proposal)
      .replace(':shippingId', shippingId)
      .replace(':status', status)
  )
}

export function getMXDataColletionGroupBySessionId(user, proposal, sessionId) {
  return (
    user.server +
    '/:token/proposal/:proposal/mx/datacollection/session/:sessionId/list'
      .replace(':token', user.token)
      .replace(':proposal', proposal)
      .replace(':sessionId', sessionId)
  )
}

export function getDiffrationThumbnail(user, proposal, imageId) {
  return (
    user.server +
    '/:token/proposal/:proposal/mx/image/:imageId/thumbnail'
      .replace(':token', user.token)
      .replace(':proposal', proposal)
      .replace(':imageId', imageId)
  )
}

export function getDozorPlot(user, proposal, dataCollectionId) {
  return (
    user.server +
    '/:token/proposal/:proposal/mx/datacollection/:dataCollectionId/qualityindicatorplot'
      .replace(':token', user.token)
      .replace(':proposal', proposal)
      .replace(':dataCollectionId', dataCollectionId)
  )
}

export function getCrystalImage(user, proposal, dataCollectionId, imageIndex) {
  return (
    user.server +
    '/:token/proposal/:proposal/mx/datacollection/:dataCollectionId/crystalsnaphot/:imageIndex/get'
      .replace(':token', user.token)
      .replace(':proposal', proposal)
      .replace(':dataCollectionId', dataCollectionId)
      .replace(':imageIndex', imageIndex)
  )
}

export function getDataCollectionByGroupId(user, proposal, dataCollectionGroupId) {
  return (
    user.server +
    '/:token/proposal/:proposal/mx/datacollection/datacollectiongroupid/:dataCollectionGroupId/list'
      .replace(':token', user.token)
      .replace(':proposal', proposal)
      .replace(':dataCollectionGroupId', dataCollectionGroupId)
  )
}

export function getAutoprocResultsByDataCollectionId(user, proposal, dataCollectionId) {
  return (
    user.server +
    '/:token/proposal/:proposal/mx/autoprocintegration/datacollection/:dataCollectionId/view'
      .replace(':token', user.token)
      .replace(':proposal', proposal)
      .replace(':dataCollectionId', dataCollectionId)
  )
}

export function getDownloadAutoprocessingFiles(user, proposal, autoprocProgramId, forcedFileName) {
  return (
    user.server +
    '/:token/proposal/:proposal/mx/autoprocintegration/attachment/autoprocprogramid/:autoprocProgramId/download?forceFilename=:forcedFileName'
      .replace(':token', user.token)
      .replace(':proposal', proposal)
      .replace(':autoprocProgramId', autoprocProgramId)
      .replace(':forcedFileName', forcedFileName)
  )
}

export function getWorkflowImage(user, proposal, stepId) {
  return (
    user.server +
    '/:token/proposal/:proposal/mx/workflow/step/:stepId/image'
      .replace(':token', user.token)
      .replace(':proposal', proposal)
      .replace(':stepId', stepId)
  )
}

export function saveDataCollectionComments(user, proposal, dataCollectionGroupId) {
  return (
    user.server +
    '/:token/proposal/:proposal/mx/datacollectiongroup/:dataCollectionGroupId/comments/save'
      .replace(':token', user.token)
      .replace(':proposal', proposal)
      .replace(':dataCollectionGroupId', dataCollectionGroupId)
  )
}

export function getWorflowStepList(user, proposal, workflowStepListIds) {
  return (
    user.server +
    '/:token/proposal/:proposal/mx/workflow/step/:workflowStepListIds/list'
      .replace(':token', user.token)
      .replace(':proposal', proposal)
      .replace(':workflowStepListIds', workflowStepListIds)
  )
}

export function getWorflowStepResultById(user, proposal, workflowStepId) {
  return (
    user.server +
    '/:token/proposal/:proposal/mx/workflow/step/:workflowStepId/result'
      .replace(':token', user.token)
      .replace(':proposal', proposal)
      .replace(':workflowStepId', workflowStepId)
  )
}

export function getPhasingByDataCollectionGroupId(user, proposal, dataCollectionGroupId) {
  return (
    user.server +
    '/:token/proposal/:proposal/mx/phasing/datacollectiongroupid/:dataCollectionGroupId/list'
      .replace(':token', user.token)
      .replace(':proposal', proposal)
      .replace(':dataCollectionGroupId', dataCollectionGroupId)
  )
}

export function downloadPhasingFilesByPhasingAttachmentId(user, proposal, phasingAttachmentId) {
  return (
    user.server +
    '/:token/proposal/:proposal/mx/phasing/phasingprogramattachmentid/:phasingAttachmentId/download'
      .replace(':token', user.token)
      .replace(':proposal', proposal)
      .replace(':phasingAttachmentId', phasingAttachmentId)
  )
}

export function getCSVPhasingFilesByPhasingAttachmentIdURL(user, proposal, phasingAttachmentId) {
  return (
    user.server +
    '/:token/proposal/:proposal/mx/phasing/phasingprogramattachmentid/:phasingAttachmentId/csv'
      .replace(':token', user.token)
      .replace(':proposal', proposal)
      .replace(':phasingAttachmentId', phasingAttachmentId)
  )
}

export function getDownloadFilesByPhasingStepIdURL(user, proposal, phasingStepId) {
  return (
    user.server +
    '/:token/proposal/:proposal/mx/phasing/phasingstepid/:phasingStepId/download'
      .replace(':token', user.token)
      .replace(':proposal', proposal)
      .replace(':phasingStepId', phasingStepId)
  )
}

export function getPhasingFilesByPhasingProgramAttachmentIdAsImage(user, proposal, phasingAttachmentId) {
  return (
    user.server +
    '/:token/proposal/:proposal/mx/phasing/phasingprogramattachmentid/:phasingAttachmentId/image'
      .replace(':token', user.token)
      .replace(':proposal', proposal)
      .replace(':phasingAttachmentId', phasingAttachmentId)
  )
}

export function getElectronViewer(pdb, map1, map2) {
  return 'https://exi.esrf.fr/viewer/uglymol/index.html?pdb=:pdb&map1=:map1&map2=:map2'
    .replace(':pdb', pdb)
    .replace(':map1', map1)
    .replace(':map2', map2)
}

function getXScaleStatistics(user, proposal, autoprocIntegrations, stats) {
  return (
    user.server +
    '/:token/proposal/:proposal/mx/autoprocintegration/:autoprocIntegrations/xscale/:stats'
      .replace(':token', user.token)
      .replace(':proposal', proposal)
      .replace(':autoprocIntegrations', autoprocIntegrations)
      .replace(':stats', stats)
  )
}

export function getCC2(user, proposal, autoprocIntegrations) {
  return getXScaleStatistics(user, proposal, autoprocIntegrations, 'cc2')
}

export function getAnomalousCorrelation(user, proposal, autoprocIntegrations) {
  return getXScaleStatistics(user, proposal, autoprocIntegrations, 'anomcorr')
}

export function getSigmaAnomalous(user, proposal, autoprocIntegrations) {
  return getXScaleStatistics(user, proposal, autoprocIntegrations, 'sigmaano')
}

export function getRFactor(user, proposal, autoprocIntegrations) {
  return getXScaleStatistics(user, proposal, autoprocIntegrations, 'rfactor')
}

export function getCompleteness(user, proposal, autoprocIntegrations) {
  return getXScaleStatistics(user, proposal, autoprocIntegrations, 'completeness')
}

export function getISigma(user, proposal, autoprocIntegrations) {
  return getXScaleStatistics(user, proposal, autoprocIntegrations, 'isigma')
}

export function getAttachmentByAutoprocProgramId(user, proposal, autoprocProgramId) {
  return (
    user.server +
    '/:token/proposal/:proposal/mx/autoprocintegration/attachment/autoprocprogramid/:autoprocProgramId/list'
      .replace(':token', user.token)
      .replace(':proposal', proposal)
      .replace(':autoprocProgramId', autoprocProgramId)
  )
}

export function getDownloadAttachmentByAutoprocAttachmentId(user, proposal, autoprocAttachmentId) {
  return (
    user.server +
    '/:token/proposal/:proposal/mx/autoprocintegration/autoprocattachmentid/:autoprocAttachmentId/get'
      .replace(':token', user.token)
      .replace(':proposal', proposal)
      .replace(':autoprocAttachmentId', autoprocAttachmentId)
  )
}

export function getSamplesByContainerIdURL(user, proposal, containerId) {
  return (
    user.server +
    '/:token/proposal/:proposal/mx/sample/containerid/:containerId/list'
      .replace(':token', user.token)
      .replace(':proposal', proposal)
      .replace(':containerId', containerId)
  )
}

export function getUpdateSampleChangerLocationURL(user, proposal, containerId, beamline) {
  return (
    user.server +
    '/:token/proposal/:proposal/container/:containerId/beamline/:beamline/samplechangerlocation/update'
      .replace(':token', user.token)
      .replace(':proposal', proposal)
      .replace(':containerId', containerId)
      .replace(':beamline', beamline)
  )
}

export function getUpdateBeamLineNameURL(user, proposal, containerId, beamline) {
  return (
    user.server +
    '/:token/proposal/:proposal/container/:containerId/beamline/:beamline/beamlinename/update'
      .replace(':token', user.token)
      .replace(':proposal', proposal)
      .replace(':containerId', containerId)
      .replace(':beamline', beamline)
  )
}

export function getMXDewarsByProposal(user, proposal) {
  return (
    user.server + '/:token/proposal/:proposal/dewar/list'.replace(':token', user.token).replace(':proposal', proposal)
  )
}
